import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Toolbar} from '@mui/material';
import {Button} from '@mui/material';
import ErrorView from '~common/components/error-view';
import LoadingView from '~common/components/loading-view';
import {Theme} from '@mui/styles';
import {APIError} from '~common/lib/types';
import {FormControl, Input, InputLabel, Select, MenuItem} from '@mui/material';
import RendererRegistry from '~common/lib/renderers';

const viewPadding = 10
const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    height: '100%'
  },
  view: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: viewPadding
  },
  select: {
    // width: '100%'
    width: `calc(100% - ${viewPadding * 2}px)`
  },
  description: {
    width: '100%',
    flexGrow: 10,
    padding: 15
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: `calc(100% - ${viewPadding * 2}px)`
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  error?: APIError;
  data: any;
  open: boolean;
  selectedDocument: any;
  // ATTENTION: jdouglas This is a good technique for limiting possible values.  An Enum could also be used. Thu Dec 14 08:54:06 2017
  status: 'loading' | 'ready';
};

class ExternalLinkCard extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      open: false,
      selectedDocument: null 
    };
  }

  static register = () => {
    if (!RendererRegistry.find('ExternalLinkCardRenderer')) {
      // console.log('Registering ExternalLinkCardRenderer');
      RendererRegistry.register(
        'ExternalLinkCardRenderer',
        withStyles(styles)(ExternalLinkCard)
      );
    }
  };

 componentDidMount() {
    request
      .get('/api/links/query/list')
      .then((resp) => {
        let data: any = {};
        if (resp.statusCode != 200) {
          this.setState({error: resp.body, status: 'ready'});
          return;
        }
        data = resp.body;
        this.setState({data: data, error: null, status: 'ready'});
      })
      .catch((err) => {
        this.setState({error: err, status: 'ready'});
      });
  }

  handleSelectDocument = (evt: any) => {
    // console.log(evt.target.value);
    const {data} = this.state
    var sd:any = null
    if(data && data.items){
      sd = data.items.find((i)=>{
        return (i.href == evt.target.value)
      })
    }
    this.setState({
      open: false,
      selectedDocument: sd,
      error: null
    });
    // console.log("Doc Ref: ", sd)
  };

  handleGoClick = (evt: any) => {
    const {selectedDocument} = this.state
    if(selectedDocument){
      const parsed = new URL(selectedDocument.href);
      if (parsed.host == window.location.host && parsed.pathname.indexOf("/api/attachment-storage") == -1) {
        window.location.href = selectedDocument.href
      } else {
        window.open(selectedDocument.href, "_blank"); 
      }
    }
    this.setState({open: false, selectedDocument: null, error: null});
  };

  render() {
    const {
      classes,
      history
    }: {classes: ClassNameMap; history: any} = this.props;
    const {data, error, status, selectedDocument, open} = this.state;

    var errorView;
    if (error) {
      errorView = <ErrorView classes={{}} error={error} />;
    }

    var view;
    if (status === 'loading') {
      view = <LoadingView classes={{}} />;
    } else {
      var sd = "_nullOption"
      var description = ""

      if(selectedDocument){
        sd = selectedDocument.href
        description = selectedDocument.description
      }

      view = (
        <div className={classes.view}>
          <FormControl className={classes.select}>
            <InputLabel
              error={error}
              shrink
              htmlFor="select">
              Select Document
            </InputLabel>
            <Select
              name="docselect"
              error={error}
              value={sd}
              onChange={this.handleSelectDocument}
              input={<Input id="docselectinput" />}
              // MenuProps={{
              //   PaperProps: {
              //     style: {maxHeight: 300}
              //   }
              // }}
              // onKeyPress={(event: any) => {
              //   var keyPress = event.key;
              //   var listID: string = '';
              //   (options || []).map((o: any, i: number) => {
              //     if (
              //       listID === '' &&
              //       o.label.toLowerCase().charAt(0) == keyPress.toLowerCase()
              //     ) {
              //       listID = fd.key + '_' + i;
              //       if (document.getElementById(listID) != null) {
              //         const el = document.getElementById(listID);
              //         if (el) {
              //           el.scrollIntoView({behavior: 'smooth'});
              //         }
              //       }
              //     }
              //   });
              // this.setState({open: true});
              // }}>
            >
              <MenuItem value="_nullOption"></MenuItem>
              {data.items.map((c: any, idx: number) => {
                return (
                  <MenuItem id={'_' + idx} key={idx} value={c.href}>
                    {c.title}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
         <div className={classes.description}>
          {description}  
        </div>
         <div className={classes.buttons}>
          <Button disabled={!selectedDocument} variant="contained" color="primary" onClick={this.handleGoClick}>Open</Button>
        </div>
        </div>
      );
    }

    return (
      <div className={classes.container}>
        {errorView}
        {view}
      </div>
    );
  }
}

export default withStyles(styles)(ExternalLinkCard);
